import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { ReactComponent as DaiStarIcon } from 'images/dai-star.svg'
import useStyles from './styles'
import theme from 'theme'

const LoadingMessage = () => {
  const [dotCount, setDotCount] = useState(1)

  const classes = useStyles()

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev < 3 ? prev + 1 : 1))
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <Box display="flex" gridGap={theme.spacing(1)}>
      <Box>
        <DaiStarIcon className={classes.daiIcon} />
      </Box>

      <Box width="100%">
        <Typography variant="body1" className={classes.chatMessageText}>
          Só um segundo{'.'.repeat(dotCount)}
        </Typography>

        <Skeleton
          width="90%"
          animation="wave"
          height={30}
          className={classes.skeletonWave}
        />
        <Skeleton
          width="70%"
          animation="wave"
          height={30}
          className={classes.skeletonWave}
        />
        <Skeleton
          width="50%"
          animation="wave"
          height={30}
          className={classes.skeletonWave}
        />
      </Box>
    </Box>
  )
}

export default LoadingMessage
